// extracted by mini-css-extract-plugin
export default {"wrapper":"CookieSettings_wrapper__-waeg"};